import { createSelector } from 'reselect'

export const getCurrentUser = state => state.static_data.current_user

export const userName = createSelector([getCurrentUser], user => user.name)

// TODO: refactor with candidateList
export const getAccountManager = state => state.static_data.company.account_manager

export const isCompanyAccountManager = createSelector([getCurrentUser], user => user.is_account_manager)

// TODO: refactor with positionsDashboard
export const currentUser = createSelector([getCurrentUser], user => ({
  id: user.member_id,
  name: user.name,
  email: user.email,
  firstName: user.name.split(' ')[0],
  isReviewer: user.auth_role === 'reviewer',
  isOfferzen: user.auth_role === 'offerzen_user',
  current_hiring_team: user.current_hiring_team,
  isAccountManager: user.is_account_manager,
  category: user.category,
  hubspotUrl: user.company && user.company.hub_spot_url,
}))

export const errorUser = createSelector([getCurrentUser], user => {
  if (!user || !user.id) return {}
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    role: user.auth_role,
  }
})

export const userRole = createSelector([getCurrentUser], user => user.auth_role)

export const emailPreferencesAccessTokenKey = createSelector([getCurrentUser], user => user.email_preferences_access_token_key)

export const memberProfileId = createSelector([getCurrentUser], user => user.member_id)

export const hiringTeamId = createSelector([getCurrentUser], user => user.current_hiring_team_id)

const defaultUser = { company: { enabled_features: [] } }

export const selectEnabledFeatures = createSelector([getCurrentUser], user => user.company?.enabled_features || [])
